import React from "react";
import { PanelSection } from "../../../../../ui/PanelShell";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";
import { DragNumberInput } from "../../../controls/ScrollDragNumberInput";
import { ShapeSectionOptions } from "../ShapePanel";

export const CommonPositionPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditorActions();
  const shape = shapes[0];

  const handleXChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { x: Number.parseInt(String(value), 10) });
    });
  };

  const handleYChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { y: Number.parseInt(String(value), 10) });
    });
  };

  const handleRotationChange = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { rotation: Number.parseInt(String(value), 10) });
    });
  };

  return (
    <PanelSection label="Position">
      <div className="flex flex-col gap-1.5">
        <div className="grid grid-cols-2 gap-1.5">
          <div className="flex flex-col gap-1">
            <span className="text-neutral-600 text-xs">Left</span>
            <DragNumberInput
              size={"sm"}
              presets={[]}
              value={shape.x}
              onChange={handleXChangeValue}
            />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-neutral-600 text-xs">Top</span>
            <DragNumberInput
              size={"sm"}
              presets={[]}
              value={shape.y}
              onChange={handleYChangeValue}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-1.5">
          <div className="flex flex-col gap-1">
            <span className="text-neutral-600 text-xs">Rotation</span>
            <DragNumberInput
              size={"sm"}
              presets={[]}
              value={Number(shape.rotation || 0)}
              onChange={handleRotationChange}
              max={360}
              min={-360}
            />
          </div>
        </div>
      </div>
    </PanelSection>
  );
};
